import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setMode } from 'state';
import { 
  Menu as MenuIcon, 
  X, 
  Sun, 
  Moon, 
  LogOut, 
  ChevronDown 
} from 'lucide-react';

const Navbar = ({ isSidebarOpen, setIsSidebarOpen, isMobile }) => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.global.mode);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  const toggleMode = () => {
    dispatch(setMode());
    setUserMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 z-40 flex h-16 w-full items-center justify-between border-b border-border bg-card px-4 md:px-6">
        <div className="flex items-center">
          {isMobile && (
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-md hover:bg-accent"
              aria-label="Toggle sidebar"
            >
              {isSidebarOpen ? <X size={20} /> : <MenuIcon size={20} />}
            </button>
          )}

          {!isMobile && (
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground mr-2">
              TR
            </div>
          )}

          <h1 className="text-lg font-semibold">
            CÓDIGO DE DESCONTO
          </h1>
        </div>

        <div className="flex items-center gap-4">
          <div className="relative">
            <button
              onClick={toggleUserMenu}
              className="flex items-center space-x-1 rounded-full focus:outline-none"
              aria-expanded={userMenuOpen}
              aria-haspopup="true"
            >
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground">
                TR
              </div>
              <ChevronDown size={16} className={`transition-transform duration-200 ${userMenuOpen ? 'rotate-180' : ''}`} />
            </button>

            {userMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-card shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button">
                  <button
                    onClick={toggleMode}
                    className="flex w-full items-center px-4 py-2 text-sm hover:bg-accent"
                    role="menuitem"
                  >
                    {mode === 'dark' ? (
                      <>
                        <Sun size={16} className="mr-3" />
                        <span>Modo Claro</span>
                      </>
                    ) : (
                      <>
                        <Moon size={16} className="mr-3" />
                        <span>Modo Escuro</span>
                      </>
                    )}
                  </button>
                  
                  <Link
                    to="/logout"
                    className="flex w-full items-center px-4 py-2 text-sm hover:bg-accent"
                    role="menuitem"
                    onClick={() => setUserMenuOpen(false)}
                  >
                    <LogOut size={16} className="mr-3" />
                    <span>Sair</span>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;